import { callPostApi } from "./api";

export async function getAddressTypeList() {
      try {
            const response = await callPostApi({ url: "address-types/list" });
            return response;
      } catch (error) {
            throw error;
      }
}

